import { Skeleton } from '@mui/material';
import useSharedVisibility from '../../hooks/useSharedVisibility';
import type { FilterItem } from '../../hooks/useUrlFilters';
import type { TreeTotalsType, TreeType, TreeViewBy } from '../../types';
import type { Totals } from '../../types/types';
import { TestResultsChips } from '../ChipList';
import { useTreeNodeTotals } from './hooks/useTreeNodeTotals';
import AsyncTreeNodeChips from './AsyncTreeNodeChips';

export type AsyncTreeNodeTotalsChipsProps = {
  category: TreeType;
  view: TreeViewBy;
  daysBack: number;
  filters: FilterItem[];
  kind: TreeTotalsType;
  requestKey: string;
};

const ChipsSkeleton = () => (
  <Skeleton variant="rounded" width={16} height={20} sx={{ flexShrink: 0 }} />
);

const AsyncTreeNodeTotalsChips = (props: AsyncTreeNodeTotalsChipsProps) => {
  const [ref, visible] = useSharedVisibility<HTMLDivElement>('100px');
  const { data, isLoading } = useTreeNodeTotals({ ...props, enabled: visible });

  return (
    <AsyncTreeNodeChips<Totals>
      containerRef={ref}
      visible={visible}
      data={data}
      isLoading={isLoading}
      renderSkeleton={() => <ChipsSkeleton />}
      renderContent={(totals) => (
        <TestResultsChips totals={totals} hideEmptyState size="medium" />
      )}
    />
  );
};

export default AsyncTreeNodeTotalsChips;
